import { CATALOGUE_POLICES, policesDeLaCharte } from '../../contract/index.js';
import { Corps } from './Corps.js';
import { cssCartel } from './css.js';
/**
 * Polices du thème : déclarées, jamais téléchargées (D12). La publication
 * copie ces fichiers depuis le dépôt de polices d'Artosera vers `/fonts/`.
 */
function assets(charte) {
    return policesDeLaCharte(charte).flatMap((nom) => {
        const definition = CATALOGUE_POLICES[nom];
        return definition.fichiers.map((fichier) => ({
            chemin: fichier.chemin,
            type: 'police',
            description: `${definition.famille} ${String(fichier.graisse)} ${fichier.style}`,
        }));
    });
}
/**
 * Thème **Cartel**, d'après `designs/b-cartel.html` : le cartel de musée —
 * typographie éditoriale, texte d'abord, grandes marges, images sobres,
 * navigation textuelle. Pour une galerie établie (second marché, dessins).
 *
 * Mêmes composants que Cimaise (même contrat, mêmes pages) : c'est la
 * feuille de style qui fait le thème.
 */
export const cartel = {
    nom: 'cartel',
    feuilleDeStyle: '/assets/cartel.css',
    assets,
    css: cssCartel,
    Corps,
};
export { cssCartel };
//# sourceMappingURL=index.js.map